export const AuthHeader = (includeContentType: boolean = true, includeCentralizationToken: boolean = false) => {
  const rememberMe = JSON.parse(localStorage.getItem('rememberMe') || 'false');
  const token = rememberMe
    ? localStorage.getItem('AuthTokenApp')
    : sessionStorage.getItem('AuthTokenApp');

  const headers: Record<string, string> = {};
  if (token) {
    headers['Authorization'] = 'Bearer ' + token;
  }

  if (includeContentType) {
    headers['Content-Type'] = 'application/json';
  }

  if (includeCentralizationToken) {
    const centralizationToken = rememberMe
      ? localStorage.getItem('AuthToken')
      : sessionStorage.getItem('AuthToken');
    if (centralizationToken) {
      headers['atc'] = centralizationToken;
    }
  }

  return headers;
};
